import { useGetMe } from "apiClients/apiPatient";
import { Loading } from "components/atoms/Loading";
import AddPaymentMethodPage from "pages/AddPaymentMethodPage";
import UserRegisterPage from "pages/UserRegisterPage";
import { Navigate, useLocation } from "react-router-dom";

import { Session } from "./Session";

const IsLogined = (props: any) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const idToken = localStorage?.getItem("idToken");

  const { data: meData, isLoading } = useGetMe({
    query: { enabled: !!idToken },
  });

  const searchParams = new URLSearchParams(location.search);
  const doctorId = searchParams.get("doctorId");
  if (doctorId) {
    localStorage.setItem("doctorId", doctorId);
  }

  if (!idToken) {
    const currentUrl = encodeURIComponent(
      window.location.pathname + window.location.search
    );
    return <Navigate to={`/login?done=${currentUrl}`} />;
  }

  if (isLoading) {
    return <Loading isLoading />;
  }

  if (meData?.patient.finishedInitRegister) {
    return (
      <>
        <Session />
        {props.children}
      </>
    );
  } else {
    if (currentPath === "/userRegister") {
      return (
        <>
          <Session />
          <UserRegisterPage />
        </>
      );
    } else if (currentPath === "/addPaymentMethod") {
      return (
        <>
          <Session />
          <AddPaymentMethodPage />
        </>
      );
    } else {
      return (
        <>
          <Session />
          <UserRegisterPage />
        </>
      );
    }
  }
};
export default IsLogined;
